<template>
    <div class="outer">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="库存列表" name="1">
                <GoodsInventory v-if="activeName === '1'"/>
            </el-tab-pane>
            
            <el-tab-pane label="出入库记录" name="2" v-if="!isAdmin">
                <inOutRecord v-if="activeName === '2'" />
            </el-tab-pane>

            <template v-else>

                <el-tab-pane label="入库记录" name="3" v-if="$store.state.jxcSystemPermission.AdminRole()">
                    <inRecordAdmin v-if="activeName === '3'" />
                </el-tab-pane>

                <el-tab-pane label="出库记录" name="4" v-if="$store.state.jxcSystemPermission.AdminRole()">
                    <outRecordAdmin v-if="activeName === '4'" />
                </el-tab-pane>
                
            </template>

        </el-tabs>
    </div>
</template>
<script>
import GoodsInventory from './components/GoodsInventory.vue';
import inOutRecord from './components/inOutRecord.vue';
import inRecordAdmin from './components/inRecordAdmin.vue';
import outRecordAdmin from './components/outRecordAdmin.vue';
export default {
    data() {
        return {
            //是否是行政（admin 1 / 行政总监 48 / 行政人员 31）
            isAdmin: sessionStorage.getItem('userRoleId') === '1' || sessionStorage.getItem('userRoleId') === '48' || sessionStorage.getItem('userRoleId') === '31',
            // sessionStorage.getItem('userRoleId') === '48' || sessionStorage.getItem('userRoleId') === '31',
            activeName: '1',
        }
    },
    components: {
        GoodsInventory,
        inOutRecord,
        inRecordAdmin,
        outRecordAdmin,
    },
    created() {
        // 判断是否是跳转过来的
        if (this.$route.params.inNo) {
            this.activeName = '3';
        }

    },
    computed: {

    },
    methods: {
        // 切换tab栏

    },
}
</script>
<style lang="scss" scoped></style>
